import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, List } from '@pella/sash-framework';
import { CTA } from '../../';
import { isValidArray } from '../../utilities/validations';

const AnchorLinks = ({ data, buttonText = 'Select Section', currentUrl, className, dark, editTags }) => {
	const [showMenu, setShowMenu] = useState(false);

	const onSelectClick = () => setShowMenu(!showMenu);

	if (!data) return null;

	return (
		<div
			className={`mb-8 mt-12 md:mb-12 md:mt-16 ${className || ''}`}
			data-testid='anchor-links'
		>
			<button
				aria-expanded={showMenu}
				onClick={() => onSelectClick()}
				className={`relative mx-auto block w-full cursor-pointer border-2 border-black p-2.5 text-sm font-semibold uppercase sm:w-[300px] lg:hidden ${dark ? '!border-white text-white' : ''}`}
			>
				{buttonText || 'Select'}
				<Icon
					name='arrow_drop_down'
					className='absolute right-2 top-1/2 -translate-y-1/2'
					size={28}
				/>
			</button>

			<List
				bullets='none'
				className={`mx-auto mb-8 w-full flex-wrap max-lg:border-2 max-lg:border-t-0 max-lg:border-black sm:w-[300px] sm:items-center sm:justify-center md:mb-16 lg:mx-0 lg:w-auto ${showMenu ? 'sm:flex' : 'hidden lg:flex'}`}
			>
				{isValidArray(data) &&
					data.map((link, index) => (
						<li
							key={index}
							className='max-lg:w-full lg:flex-none lg:p-1'
						>
							<CTA
								{...(editTags?.[`cta__${index}`] ?? {})}
								data={{
									...link,
									link: { ...link.link, title: currentUrl === link.link.href ? `${link.link.title} (Currently On)` : link.link.title },
								}}
								className={`!w-full max-lg:!justify-start max-lg:border-0 max-lg:border-b max-lg:border-b-neutral-300 max-lg:bg-transparent max-lg:px-4 max-lg:py-2 max-lg:text-left max-lg:text-black ${currentUrl === link.link.href ? 'pointer-events-none opacity-70' : ''}`}
							/>
						</li>
					))}
			</List>
		</div>
	);
};

AnchorLinks.propTypes = {
	data: PropTypes.array,
	buttonText: PropTypes.string,
	currentUrl: PropTypes.string,
	className: PropTypes.string,
	dark: PropTypes.bool,
	editTags: PropTypes.object,
};

export default AnchorLinks;
